// extracted by mini-css-extract-plugin
export default {"icon":"OrderIcon_icon__aCfmu"};